export default Object.hasOwn;
